import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getPaymentUrl } from '../../actions/makePayment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Payment.css'

function MakePayment() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [decodedIds, setDecodedIds] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const paymentData = useSelector(state => state.getPaymentUrlReducer?.payment);
  console.log("paymentData",paymentData);
  

  useEffect(() => {
    try {
      const decoded = atob(decodeURIComponent(id));
      console.log("decoded", decoded);

      if (/^(\d+,)*\d+$/.test(decoded)) {
        setDecodedIds(decoded);
        setIsValid(true);
      } else {
        setDecodedIds('Invalid or corrupted ID');
      }
    } catch (error) {
      console.error('Decoding failed:', error);
      setDecodedIds('Invalid or corrupted ID');
    }
  }, [id]);

  const GeneratePaymentLink = async () => {
    const parsedIds = decodedIds.split(',').map(Number);
    setIsLoading(true);

    try {
      await dispatch(getPaymentUrl({ courseIDs: parsedIds }));
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (paymentData?.PaymentLink) {
      toast.success("Redirecting to payment page...");
      setTimeout(() => {
        window.location.href = paymentData.PaymentLink;
      }, 1500);
    }
  }, [paymentData]);
  

  return (
    <div className="payment-container">
    <ToastContainer />
    <div className="payment-card">
      <h2>Make Payment</h2>
      <p className="subtext">Below are your course ID(s):</p>

      <div className="course-id">{decodedIds}</div>

      {isValid ? (
        <button
          onClick={GeneratePaymentLink}
          disabled={isLoading}
          className="payment-button"
        >
          {isLoading ? 'Processing...' : 'Proceed to Payment'}
        </button>
      ) : (
        <p className="error-message">Invalid or corrupted course ID</p>
      )}
    </div>
  </div>
  );
}

export default MakePayment;
